import { render, staticRenderFns } from "./FormRegua.vue?vue&type=template&id=59f2e578"
import script from "./FormRegua.vue?vue&type=script&lang=js"
export * from "./FormRegua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports